import WindowSillsForm from './WindowSillsForm';

export default WindowSillsForm;